
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 94 1"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradient","y1":".613","x2":"1","y2":".5","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#ed479a","stop-opacity":"0"}}),_c('stop',{attrs:{"offset":".276","stop-color":"#ed479a"}}),_c('stop',{attrs:{"offset":".768","stop-color":"#a689ff"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#a689ff","stop-opacity":"0"}})])]),_c('rect',{attrs:{"id":"Rectangle_16700","data-name":"Rectangle 16700","width":"94","height":"1","fill":"url(#linear-gradient)"}})])
          )
        }
      }
    